import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { deleteFavoriteItem } from 'src/app/home/ngrx/home-actions';

@Component({
  selector: 'app-delete-favorite',
  templateUrl: './delete-favorite.component.html',
  styleUrls: ['./delete-favorite.component.scss',  '../../../../home/home.component.scss']
})
export class DeleteFavoriteComponent implements OnInit {
  @Input() favId!:number;

  constructor(private store:Store) { }

  ngOnInit(): void {
  }

  onClick_deleteFavoriteItem() {
    this.store.dispatch(deleteFavoriteItem({favId:String(this.favId)}));
  }
}
